import { FiUser, FiMail } from "react-icons/fi";

const MetaItem = ({ label, value }) => (
    <div className="flex items-baseline gap-1.5">
        <span className="text-[10px] uppercase tracking-wide text-slate-400">{label}</span>
        <span className="truncate text-xs font-semibold text-slate-700">{value}</span>
    </div>
);

const Stat = ({ label, value, accent }) => (
    <div className={`rounded-lg p-3 ${accent}`}>
        <div className="text-[10px] uppercase tracking-wide text-slate-400">{label}</div>
        <div className="mt-1 text-lg font-bold tabular-nums text-slate-900">{value}</div>
    </div>
);

const MarketingVisitorCard = ({ visitor, onViewJourney }) => {
    if (visitor === undefined) {
        return <></>;
    }
    if (visitor === null) {
        return (
            <div className="rounded-xl border border-dashed border-slate-200 bg-white p-10 text-center">
                <FiMail size={30} className="mx-auto text-slate-300" />
                <h3 className="mt-3 text-base font-semibold text-slate-900">
                    No Visitor Found
                </h3>
                <p className="mt-1 text-xs text-slate-500">
                    No visitor matched the email address you searched.
                </p>
            </div>
        );
    }

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-indigo-50/40 to-white p-5">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex min-w-0 items-center gap-3">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-indigo-100">
                        <FiUser size={18} className="text-indigo-600" />
                    </div>
                    <h2 className="truncate text-base font-semibold text-slate-900">{visitor.email}</h2>
                </div>

                <div className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg bg-white/70 px-3.5 py-2 ring-1 ring-slate-100">
                    <MetaItem label="Type:" value={visitor.user_type || "Guest"} />
                    <span className="hidden h-3 w-px bg-slate-200 sm:block" />
                    <MetaItem label="Source:" value={visitor.source || "Direct"} />
                    <span className="hidden h-3 w-px bg-slate-200 sm:block" />
                    <MetaItem label="Campaign:" value={visitor.campaign || "No Campaign"} />
                </div>
            </div>

            <div className="mt-5 grid grid-cols-3 gap-2.5 md:grid-cols-6">
                <Stat label="Pricing Views" value={visitor.pricing_views} accent="bg-sky-50" />
                <Stat label="Plans" value={visitor.plans} accent="bg-violet-50" />
                <Stat label="Checkout" value={visitor.checkout} accent="bg-amber-50" />
                <Stat label="Payments" value={visitor.payments} accent="bg-orange-50" />
                <Stat label="Revenue" value={`$${visitor.revenue}`} accent="bg-emerald-50" />
                <Stat
                    label="Last Seen"
                    value={new Date(visitor.last_seen).toLocaleDateString()}
                    accent="bg-slate-50"
                />
            </div>

            <div className="mt-5 flex justify-end">
                <button
                    onClick={() => onViewJourney(visitor)}
                    className="rounded-lg bg-indigo-600 px-4 py-2 text-xs font-medium text-white transition hover:bg-indigo-700"
                >
                    View Complete Journey →
                </button>
            </div>
        </div>
    );
};

export default MarketingVisitorCard;